import {
  MY_COMPLAINTS_REQUEST,
  MY_COMPLAINTS_SUCCESS,
  MY_COMPLAINTS_FAIL,

  ADMIN_COMPLAINTS_REQUEST,
  ADMIN_COMPLAINTS_SUCCESS,
  ADMIN_COMPLAINTS_FAIL,

  STORE_COMPLAINTS_REQUEST,
  STORE_COMPLAINTS_SUCCESS,
  STORE_COMPLAINTS_FAIL,
} from "../constants/complaintConstant";

// ================= MY COMPLAINTS =================
export const myComplaintsReducer = (
  state = { complaints: [] },
  action
) => {
  switch (action.type) {
    case MY_COMPLAINTS_REQUEST:
      return { loading: true, complaints: [] };

    case MY_COMPLAINTS_SUCCESS:
      return { loading: false, complaints: action.payload };

    case MY_COMPLAINTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

// ================= ADMIN COMPLAINTS =================
export const adminComplaintsReducer = (
  state = { complaints: [] },
  action
) => {
  switch (action.type) {
    case ADMIN_COMPLAINTS_REQUEST:
      return { loading: true, complaints: [] };

    case ADMIN_COMPLAINTS_SUCCESS:
      return { loading: false, complaints: action.payload };

    case ADMIN_COMPLAINTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

// ================= STORE COMPLAINTS =================
export const storeComplaintsReducer = (
  state = { complaints: [] },
  action
) => {
  switch (action.type) {
    case STORE_COMPLAINTS_REQUEST:
      return { loading: true, complaints: [] };

    case STORE_COMPLAINTS_SUCCESS:
      return { loading: false, complaints: action.payload };

    case STORE_COMPLAINTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
